export default "<style scoped>\n  .something {\n    color: var(--v-primary-base);\n    background-color: var(--v-accent-lighten2);\n  }\n</style>\n";